module.exports = __webpack_public_path__ + "static/media/Linkedin.45485ce2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/Linkedin.svg
// module id = 384
// module chunks = 16